import * as React from 'react'
import { Grid, Typography } from '@mui/material'
import FilterTable from './FilterTable'
import BrandedPageHeader from 'components/Layout/BrandedPageHeader'

export default function Filters() {
  return (
    <>
      <BrandedPageHeader>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <Typography variant='h5' sx={{ color: 'white', fontWeight: 'bold' }}>
              My Filters
            </Typography>
          </Grid>
        </Grid>
      </BrandedPageHeader>

      <Grid container item xs={12} justifyContent='center' sx={{ mt: 4 }}>
        <Grid container item xs={11}>
          <FilterTable />
        </Grid>
      </Grid>
    </>
  )
}
